module.exports = __webpack_public_path__ + "img/icon_management_color.9af49312.svg";